// Inject CSS into the kwipped approve-button web component's shadow root.
// Wrapped in an IIFE so identifiers don't leak into the global scope and clash
// with other scripts that may also declare `observer` etc.
(() => {
  function injectShadowRootStyles() {
    const approveButton = document.querySelector('approve-button#approve_button_id');
    if (!approveButton || !approveButton.shadowRoot) return;
    const shadowRoot = approveButton.shadowRoot;

    // Check if styles already injected
    if (shadowRoot.querySelector('style[data-custom-styles]')) return;

    // Create style element with the CSS rules
    const style = document.createElement('style');
    style.setAttribute('data-custom-styles', 'true');
    style.textContent = `
      .btn_l_container {
        color: var(--Brand-Black, #000) !important;
        font-family: Gilroy-Medium !important;
        font-size: 12px !important;
        font-weight: 400 !important;
        line-height: normal !important;
        display: flex !important;
        height: min-content !important;
        padding: 0 !important;
        flex-direction: row !important;
        border: unset !important;
        box-shadow: unset !important;
        width: max-content !important;
        background: unset !important;
      }

      .btn_r_container {
        color: var(--Brand-Black, #000) !important;
        font-family: Gilroy-Medium !important;
        font-size: 12px !important;
        font-weight: 400 !important;
        line-height: normal !important;
        height: min-content !important;
        width: unset !important;
        padding: unset !important;
        display: flex !important;
        flex-direction: row !important;
        border-radius: unset !important;
        background: unset !important;
        border: unset !important;
        box-shadow: unset !important;
      }

      .desc-text {
        display: none !important;
      }
    `;

    // Inject the style into the shadow root
    shadowRoot.appendChild(style);
  }

  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectShadowRootStyles, { once: true });
  } else {
    injectShadowRootStyles();
  }

  // Watch for dynamically-added approve-button elements (the kwipped widget mounts late).
  const shadowRootObserver = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.tagName === 'APPROVE-BUTTON' || (node.querySelector && node.querySelector('approve-button'))) {
          setTimeout(injectShadowRootStyles, 100);
        }
      }
    }
  });

  shadowRootObserver.observe(document.body || document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
